const topServiceCategoryGroup = state => state.topServiceCategoryGroup;
const selectedServices = state => state.selectedServices;
const optionalMaintenancePositions = state => state.maintenancePositions.filter(pos => pos.optional);
const requiredMaintenancePositions = state => state.maintenancePositions.filter(pos => !pos.optional);
const maintenancePositions = state => state.maintenancePositions;

export default {
  topServiceCategoryGroup,
  selectedServices,
  optionalMaintenancePositions,
  requiredMaintenancePositions,
  maintenancePositions
};
